import { render, staticRenderFns } from "./BusinessCampaignCard.vue?vue&type=template&id=3c65a8d2&"
import script from "./BusinessCampaignCard.vue?vue&type=script&lang=js&"
export * from "./BusinessCampaignCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports